namespace GeniuzPOS.Lookups {
    export interface LookupTxtColorForm {
        TxtColor: Serenity.StringEditor;
        TxtColorName: Serenity.StringEditor;
    }

    export class LookupTxtColorForm extends Serenity.PrefixedContext {
        static formKey = 'Lookups.LookupTxtColor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LookupTxtColorForm.init)  {
                LookupTxtColorForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(LookupTxtColorForm, [
                    'TxtColor', w0,
                    'TxtColorName', w0
                ]);
            }
        }
    }
}
